<template>
    <v-row align="center" class="ma-0">
        <v-col cols="auto" style="width: 160px">
            <v-btn outlined color="rgba(0,0,0,.42)" @click="goToday">
                <span style="color: rgba(0, 0, 0, 0.87)">오늘</span>
            </v-btn>
        </v-col>
        <v-spacer />
        <calendar-header-month v-if="type == 'month'" v-bind="{ value }" v-on="{ input }" />
        <calendar-header-week v-if="type == 'week'" v-bind="{ value }" v-on="{ input }" />
        <calendar-header-date v-if="type == 'category'" v-bind="{ value }" v-on="{ input }" />
        <v-spacer />
        <v-col cols="auto" style="width: 160px">
            <v-select :value="type" :items="types" label="유형" v-bind="attrs_input" v-on="{ change }" />
        </v-col>
    </v-row>
</template>

<script>
import { attrs_input } from "@/assets/variables";

import CalendarHeaderMonth from "./calendar-header-month.vue";
import CalendarHeaderWeek from "./calendar-header-week.vue";
import CalendarHeaderDate from "./calendar-header-date.vue";

let types = [
    { text: "월", value: "month" },
    { text: "주", value: "week" },
    { text: "라인별", value: "category" },
];

export default {
    components: {
        CalendarHeaderMonth,
        CalendarHeaderWeek,
        CalendarHeaderDate,
    },
    props: {
        value: { type: String, default: Date.now().toDate() }, // date
        type: { type: String, default: "month" },
    },
    data: () => ({
        types,
        attrs_input,
    }),
    methods: {
        input(date) {
            this.$emit("input", date);
        },
        change(type) {
            this.$emit("typeChange", type);
        },
        goToday() {
            this.$emit("input", Date.now().toDate());
        },
    },
};
</script>

<style></style>
